<!-- Both faces reproduce the installed PrimeNG toast's class names and severity-icon switch
     byte-for-byte (p-toast-message-content / -icon / -text / -summary / -detail /
     -close-button / -close-icon + the data-p severity stamp) so the theme CSS and the global
     align-items override keep matching — headless replaces the rendering, never the chrome. -->
@if (action; as act) {
  <!-- ACTION face: severity icon + ONE detail sentence + text action button + close.
       No summary line by ruling; the button precedes close in tab order. -->
  <div
    class="p-toast-message-content"
    [attr.data-p]="severityDataP"
    (mouseenter)="onHoverStart()"
    (mouseleave)="onHoverEnd()"
    (focusin)="onFocusIn()"
    (focusout)="onFocusOut($event)"
  >
    @switch (message().severity) {
      @case ('success') {
        <svg data-p-icon="check" class="p-toast-message-icon" aria-hidden="true" />
      }
      @case ('error') {
        <svg data-p-icon="times-circle" class="p-toast-message-icon" aria-hidden="true" />
      }
      @case ('warn') {
        <svg data-p-icon="exclamation-triangle" class="p-toast-message-icon" aria-hidden="true" />
      }
      @default {
        <svg data-p-icon="info-circle" class="p-toast-message-icon" aria-hidden="true" />
      }
    }
    <div class="p-toast-message-text" [attr.data-p]="severityDataP">
      <div class="p-toast-detail" [attr.data-p]="severityDataP">
        {{ detail || (detailKey | translate: detailParams) }}
      </div>
    </div>
    <button
      pButton
      [text]="true"
      size="small"
      class="action-toast-button"
      [loading]="busy()"
      [disabled]="busy()"
      (click)="onActionClick()"
      [attr.aria-label]="act.labelKey | translate"
    >
      {{ act.labelKey | translate }}
    </button>
    <div>
      <button
        class="p-toast-close-button"
        type="button"
        (click)="onClose($event)"
        (keydown.enter)="onClose($event)"
        [attr.aria-label]="'common.close' | translate"
        [attr.data-p]="severityDataP"
      >
        <svg data-p-icon="times" class="p-toast-close-icon" aria-hidden="true" />
      </button>
    </div>
  </div>
} @else {
  <!-- STANDARD face: the stock reproduction serving every ordinary raise site unchanged. -->
  <div class="p-toast-message-content" [attr.data-p]="severityDataP">
    @switch (message().severity) {
      @case ('success') {
        <svg data-p-icon="check" class="p-toast-message-icon" aria-hidden="true" />
      }
      @case ('error') {
        <svg data-p-icon="times-circle" class="p-toast-message-icon" aria-hidden="true" />
      }
      @case ('warn') {
        <svg data-p-icon="exclamation-triangle" class="p-toast-message-icon" aria-hidden="true" />
      }
      @default {
        <svg data-p-icon="info-circle" class="p-toast-message-icon" aria-hidden="true" />
      }
    }
    <div class="p-toast-message-text" [attr.data-p]="severityDataP">
      <div class="p-toast-summary" [attr.data-p]="severityDataP">{{ message().summary }}</div>
      <div class="p-toast-detail" [attr.data-p]="severityDataP">{{ message().detail }}</div>
    </div>
    <div>
      <!-- The bare wrapper div is structural: the theme's -25% close-button margins resolve
           against ITS inline size — dropping it throws the button out of the toast.
           autofocus is stock parity only (inert on post-load-inserted nodes). -->
      <button
        class="p-toast-close-button"
        type="button"
        (click)="onClose($event)"
        (keydown.enter)="onClose($event)"
        [attr.aria-label]="'common.close' | translate"
        autofocus
        [attr.data-p]="severityDataP"
      >
        <svg data-p-icon="times" class="p-toast-close-icon" aria-hidden="true" />
      </button>
    </div>
  </div>
}
